module.exports = __webpack_public_path__ + "img/Cutaways_house_1.c50c770b.jpg";